(function(){
  /* NOTE: all cart behaviour — drawer open/close, add, quantity, remove and
     variant selection — lives in poa-cart.js. Two scripts owning the cart is
     what caused add-to-cart to ignore the selected size. Do not re-add cart
     handlers here. */
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* BOOT */
  const boot = document.getElementById('boot');
  const lines = document.querySelectorAll('#terminal .line');
  const seal = document.getElementById('bootSeal');
  const eye = document.getElementById('eye');
  const skipBtn = document.getElementById('skipBoot');
  function reveal() {
    if (!boot) return;
    boot.classList.add('done');
    if (eye) eye.classList.add('revealed');
    document.body.style.overflow = '';
  }
  function runBoot() {
    if (!boot) return;
    if (reduced) { reveal(); return; }
    document.body.style.overflow = 'hidden';
    boot.classList.add('warmup');
    setTimeout(() => boot.classList.remove('warmup'), 1200);
    let i = 0;
    function step() {
      if (i >= lines.length) {
        if (seal) seal.classList.add('in');
        setTimeout(reveal, 900);
        return;
      }
      lines[i].style.transition = 'opacity 320ms ease';
      lines[i].style.opacity = '1';
      i++;
      setTimeout(step, 380);
    }
    setTimeout(step, 850);
  }
  if (skipBtn) skipBtn.addEventListener('click', reveal);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' || e.key === 'Enter') reveal(); }, { once: true });
  if (boot) {
    if (sessionStorage.getItem('poa_booted') === '1') { reveal(); }
    else { sessionStorage.setItem('poa_booted', '1'); runBoot(); }
    // Failsafe: kill boot after 5s no matter what
    setTimeout(reveal, 5000);
  }

  /* NAV TINT — one layout read per frame, never per scroll event */
  const nav = document.getElementById('nav');
  const terra = document.getElementById('terra');
  const dark = [eye, terra, document.querySelector('.chrome-monolith'), document.querySelector('.story-hero')].filter(Boolean);
  let tintQueued = false;
  function tintNav() {
    tintQueued = false;
    if (!nav) return;
    const navH = nav.getBoundingClientRect().bottom;
    let onDark = false;
    for (const s of dark) {
      const r = s.getBoundingClientRect();
      if (r.top < navH && r.bottom > navH) { onDark = true; break; }
    }
    if (nav.classList.contains('on-dark') !== onDark) nav.classList.toggle('on-dark', onDark);
  }
  if (nav && dark.length) {
    window.addEventListener('scroll', () => {
      if (!tintQueued) { tintQueued = true; requestAnimationFrame(tintNav); }
    }, { passive: true });
    tintNav();
  }

  /* SECTION REVEAL
     Content is only hidden once this script has run (html.poa-reveal), so a
     slow or failed script can never leave a blank page. */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduced && revealEls.length) {
    // Anything already on screen stays put — only content below the fold waits.
    const vh = window.innerHeight;
    revealEls.forEach(el => { if (el.getBoundingClientRect().top < vh * 0.94) el.classList.add('in-view'); });
    document.documentElement.classList.add('poa-reveal');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('in-view'));
  }

  /* COORDINATE TICKER */
  const coordD = document.querySelector('[data-coord-d]');
  const coordE = document.querySelector('[data-coord-e]');
  if (coordD && coordE && !reduced) {
    let dVal = 1, eVal = 4, dDir = 1, eDir = -1;
    setInterval(() => {
      if (Math.random() < 0.35) {
        dVal += dDir;
        if (dVal >= 9) { dVal = 9; dDir = -1; }
        if (dVal <= 0) { dVal = 0; dDir = 1; }
        coordD.textContent = dVal;
      }
      if (Math.random() < 0.35) {
        eVal += eDir;
        if (eVal >= 9) { eVal = 9; eDir = -1; }
        if (eVal <= 0) { eVal = 0; eDir = 1; }
        coordE.textContent = eVal;
      }
    }, 1200);
  }

  /* RAIL ARROWS */
  const track = document.getElementById('railTrack');
  const railPrev = document.getElementById('railPrev');
  const railNext = document.getElementById('railNext');
  if (track && railPrev) railPrev.addEventListener('click', (e) => { e.preventDefault(); track.scrollBy({ left: -track.clientWidth * 0.6, behavior: 'smooth' }); });
  if (track && railNext) railNext.addEventListener('click', (e) => { e.preventDefault(); track.scrollBy({ left:  track.clientWidth * 0.6, behavior: 'smooth' }); });

  if (terra) terra.classList.add('bg-loaded');

  /* PDP GALLERY THUMBS (visual only — variant selection lives in poa-cart.js) */
  const mainImg = document.getElementById('caseFileMainImg');
  const warmed = new Set();
  function warm(src) { if (src && !warmed.has(src)) { warmed.add(src); const i = new Image(); i.src = src; } }
  document.querySelectorAll('.case-file .thumb').forEach(t => {
    const src = t.getAttribute('data-image');
    t.addEventListener('pointerenter', () => warm(src), { passive: true });
    t.addEventListener('touchstart', () => warm(src), { passive: true });
    t.addEventListener('keydown', (ev) => { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); t.click(); } });
    t.addEventListener('click', () => {
      if (!src || !mainImg || t.classList.contains('active')) return;
      document.querySelectorAll('.case-file .thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const swap = () => { mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.classList.remove('is-swapping'); };
      mainImg.classList.add('is-swapping');
      const pre = new Image();
      pre.onload = pre.onerror = () => requestAnimationFrame(swap);
      pre.src = src;
    });
  });

  /* DROP TIMER (only if a target attribute exists on the timer element) */
  const timer = document.getElementById('dropTimer');
  if (timer) {
    const targetStr = timer.getAttribute('data-target');
    if (targetStr) {
      const targetDate = new Date(targetStr);
      const elD = timer.querySelector('[data-d]');
      const elH = timer.querySelector('[data-h]');
      const elM = timer.querySelector('[data-m]');
      const elS = timer.querySelector('[data-s]');
      function tick() {
        const ms = targetDate - new Date();
        if (ms <= 0) { elD.textContent = elH.textContent = elM.textContent = elS.textContent = '00'; return; }
        elD.textContent = String(Math.floor(ms / 86400000)).padStart(2,'0');
        elH.textContent = String(Math.floor(ms % 86400000 / 3600000)).padStart(2,'0');
        elM.textContent = String(Math.floor(ms % 3600000 / 60000)).padStart(2,'0');
        elS.textContent = String(Math.floor(ms % 60000 / 1000)).padStart(2,'0');
      }
      tick(); setInterval(tick, 1000);
    }
  }

  /* KONAMI POA UNLOCK */
  const sealedArchive = document.getElementById('sealed-archive');
  const archiveCloseBtn  = document.getElementById('archiveClose');
  const poaToast      = document.getElementById('poa-key-toast');
  let typed = '';
  if (archiveCloseBtn) archiveCloseBtn.addEventListener('click', () => {
    sealedArchive.classList.remove('open');
    document.body.style.overflow = '';
  });
  document.addEventListener('keydown', (ev) => {
    const tag = (ev.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || ev.target.isContentEditable) return;
    if (ev.key === 'Escape' && sealedArchive && sealedArchive.classList.contains('open')) {
      sealedArchive.classList.remove('open');
      document.body.style.overflow = '';
      return;
    }
    if (ev.key && ev.key.length === 1) {
      typed += ev.key.toUpperCase();
      if (typed.length > 3) typed = typed.slice(-3);
      if (typed === 'POA' && sealedArchive) {
        typed = '';
        sealedArchive.classList.add('open');
        document.body.style.overflow = 'hidden';
        if (poaToast) {
          poaToast.classList.add('show');
          setTimeout(() => poaToast.classList.remove('show'), 1800);
        }
      }
    }
  });
})();
